import React from "react";
import "./HowToPlay.css";
import { useT } from "../i18n";

const HowToPlay = () => {
  const { t } = useT();
  return (
    <div className="how-to-play-container">
      <h2 className="title">{t("How To Play")}</h2>
      <ol className="steps-list">
        <li>{t("Download our application from Google Play Store or from our official website.")}</li>
        <li>{t("Register with your Mobile Number, Email ID, and User Name on our platform.")}</li>
        <li>{t("Login to the application using your Mobile Number and MPIN.")}</li>
        <li>{t("Select the Game type, choose your favourite number, and start to play the game.")}</li>
        <li>{t("Get a chance to win up to 10 Lac Points.")}</li>
      </ol>
    </div>
  );
};

export default HowToPlay;